import { render, staticRenderFns } from "./dealFinance.vue?vue&type=template&id=a970ba20&scoped=true&"
import script from "./dealFinance.vue?vue&type=script&lang=js&"
export * from "./dealFinance.vue?vue&type=script&lang=js&"
import style0 from "./dealFinance.vue?vue&type=style&index=0&id=a970ba20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a970ba20",
  null
  
)

export default component.exports